import { render, staticRenderFns } from "./GraduateCapSvg.vue?vue&type=template&id=665a7238&"
import script from "./GraduateCapSvg.vue?vue&type=script&lang=ts&"
export * from "./GraduateCapSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports